module.exports = __webpack_public_path__ + "static/media/quickto-choose.4e1dc132.svg";